import { tagSettings } from './Tag/settings';
import { cardSettings } from './Card/settings';
import { radioSelectSettings } from './RadioSelect/settings';
import { alertSettings } from './Alert/settings';
import { formFieldSettings } from './FormField/settings';
import { tagInputSettings } from './TagInput/settings';
import { inputLabelSettings } from './InputLabel/settings';
import { stepHorizontalSettings } from './Stepper/components/StepHortizontal/settings';
import { stepVerticalSettings } from './Stepper/components/StepVertical/settings';
import { toastMessageSettings } from './ToastMessage/settings';
import { tabsSettings } from './Tabs/settings';
import { creditCardNumberSettings } from './CreditCardNumber/settings';
import { creditCardAddressSettings } from './CreditCardAddress/settings';
import { creditCardHolderDetailsSettings } from './CreditCardHolderDetails/settings';
import { accordionSettings } from './Accordion/settings';
import { pageHeaderTitleSettings } from './PageHeaderTitle/settings';
import { pageHeaderSubtitleSettings } from './PageHeaderSubtitle/settings';

const moleculesSettings = {
  Tag: tagSettings,
  Card: cardSettings,
  RadioSelect: radioSelectSettings,
  Alert: alertSettings,
  FormField: formFieldSettings,
  TagInput: tagInputSettings,
  InputLabel: inputLabelSettings,
  StepHorizontal: stepHorizontalSettings,
  StepVertical: stepVerticalSettings,
  ToastMessage: toastMessageSettings,
  Tabs: tabsSettings,
  CreditCardNumber: creditCardNumberSettings,
  CreditCardAddress: creditCardAddressSettings,
  CreditCardHolderDetails: creditCardHolderDetailsSettings,
  Accordion: accordionSettings,
  PageHeaderTitle: pageHeaderTitleSettings,
  PageHeaderSubtitle: pageHeaderSubtitleSettings,
};

export default moleculesSettings;
